import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import Row from '../../../ReactComponent/Row';
import Column from '../../../ReactComponent/Column';
import DownloadOrangeSmall from '../../../../assets/icons/DownloadOrangeSmall.svg';
import { ReactComponent as DownloadSmallGrey } from '../../../../assets/icons/DownloadSmallGrey.svg';
import PrimaryButton from '../../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../../lib/ui/buttons/SecondaryButton';
import { routes } from '../../../../utils/constants';
import { homeUrl } from '../../../../utils/func';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../../../_styledComponents/MDBDropdownToggle';
import { ReactComponent as CancelGrey } from '../../../../assets/icons/CancelGrey.svg';
import { ReactComponent as DuplicateShipmentGrey } from '../../../../assets/icons/DuplicateShipmentGrey.svg';
import {
  IconWrapper,
  ButtonGroup,
  LastActionsContainer,
  DropdownItem,
  StyledMDBDropdown,
  DropdownText,
  ButtonContainer,
} from '../../css';

const LastActionsTopBottomNav = (props) => {
  const {
    probillNumber,
    openBOL,
    openLabelSM,
    openLabelLG,
    cancelShipment,
    isAuthenticated,
    shipmentNumber,
  } = props;

  return (
    <ButtonGroup>
      <LastActionsContainer>
        <ButtonContainer>
          <SecondaryButton
            label={t('BillOfLading')}
            onClick={() => openBOL()}
            showArrow={false}
            iconSrc={DownloadOrangeSmall}
          />

          <StyledMDBDropdown className="dropdown">
            <MDBDropdownToggle>
              <Row>
                <Column $tablet={12}>
                  {t('Labels')}
                </Column>
                <span className="icon icon-more-options" />
              </Row>
            </MDBDropdownToggle>
            <StyledMDBDropdownMenu className="text-white bg-dark label-type" basic>
              <>
                <DropdownItem onClick={() => openLabelSM()}>
                  <IconWrapper>
                    <DownloadSmallGrey />
                  </IconWrapper>
                  <DropdownText>{t('DownloadLabelsSM')}</DropdownText>
                </DropdownItem>
                <DropdownItem onClick={() => openLabelLG()}>
                  <IconWrapper>
                    <DownloadSmallGrey />
                  </IconWrapper>
                  <DropdownText>{t('DownloadLabelsLG')}</DropdownText>
                </DropdownItem>
              </>
            </StyledMDBDropdownMenu>
          </StyledMDBDropdown>
        </ButtonContainer>

        <StyledMDBDropdown className="dropdown">
          <MDBDropdownToggle>
            <Row>
              <Column $tablet={12}>
                {t('MoreOptions')}
              </Column>
              <span className="icon icon-more-options" />
            </Row>
          </MDBDropdownToggle>
          <StyledMDBDropdownMenu className="text-white bg-dark" basic>
            <>
              <DropdownItem
                onClick={() => {
                  window.location.href = `${routes.createShipment}?recreate=true&probillNumber=${probillNumber}&shipmentNumber=${shipmentNumber}`;
                  return window.location.href;
                }}
              >
                <IconWrapper>
                  <DuplicateShipmentGrey />
                </IconWrapper>
                <DropdownText>{t('DuplicateShipment')}</DropdownText>
              </DropdownItem>

              <DropdownItem onClick={() => cancelShipment()}>
                <IconWrapper>
                  <CancelGrey />
                </IconWrapper>
                <DropdownText>{t('CancelShipment')}</DropdownText>
              </DropdownItem>

              <DropdownItem onClick={() => openBOL()} className="hideMobile">
                <IconWrapper>
                  <DownloadSmallGrey />
                </IconWrapper>
                <DropdownText>{t('BillOfLading')}</DropdownText>
              </DropdownItem>

              <DropdownItem onClick={() => openLabelSM()} className="hideMobile">
                <IconWrapper>
                  <DownloadSmallGrey />
                </IconWrapper>
                <DropdownText>{t('DownloadLabelsSM')}</DropdownText>
              </DropdownItem>

              <DropdownItem onClick={() => openLabelLG()} className="hideMobile">
                <IconWrapper>
                  <DownloadSmallGrey />
                </IconWrapper>
                <DropdownText>{t('DownloadLabelsLG')}</DropdownText>
              </DropdownItem>
            </>
          </StyledMDBDropdownMenu>
        </StyledMDBDropdown>

        <PrimaryButton
          label={t('Exit')}
          onClick={() => {
            if (window && typeof window !== 'undefined') {
              window.location.href = isAuthenticated ? routes.viewUserDashboard : homeUrl();
              return window.location.href;
            }

            return '';
          }}
        />
      </LastActionsContainer>
    </ButtonGroup>
  );
};

LastActionsTopBottomNav.propTypes = {
  probillNumber: PropTypes.number,
  openBOL: PropTypes.func,
  openLabelSM: PropTypes.func,
  openLabelLG: PropTypes.func,
  cancelShipment: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  shipmentNumber: PropTypes.string,
};

export default LastActionsTopBottomNav;
